import {Action, Card, useDialog} from 'platform/components';
import {Box} from 'platform/foundation';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import {useGetRentalOrderQuery} from '@dms/api/rental';
import {
  DOCUMENT_ACTION_COLUMNS,
  useGetDocumentDatagridActions,
} from '@dms/features/document-context';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {
  DmsDataGrid,
  type DmsDataGridProps,
  refreshDmsDatagrid,
  UploadDocumentsDialog,
} from '@dms/shared';

import {buildArray, useRequiredParams} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

export function VehicleRentalDocuments(props: Pick<DmsDataGridProps, 'maximization'>) {
  const {id: rentalOrderId} = useRequiredParams();

  const [isUploadDialogOpen, openUploadDialog, closeUploadDialog] = useDialog();

  const {data: rentalOrder} = useGetRentalOrderQuery({rentalOrderId});

  const [actionCallback, bulkSignatureAction] = useGetDocumentDatagridActions({
    contextId: rentalOrderId,
    contextTarget: 'rental-order',
    customerId: rentalOrder?.customerId,
    refreshData: () => refreshDmsDatagrid('document-context-list-rental-order'),
  });

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {rentalOrderId}]),
    [rentalOrderId]
  );

  return (
    <>
      <Card
        title={i18n.t('page.rentalOrder.labels.vehicleRentalDocuments')}
        actions={buildArray<Action>([
          {
            variant: 'link',
            type: 'button',
            leftIcon: 'action/backup',
            onClick: openUploadDialog,
            title: i18n.t('entity.document.actions.uploadDocument'),
          },
        ]).add(...bulkSignatureAction)}
      >
        <Box height={130} minHeight={50} position="relative">
          <DmsDataGrid
            maximization={props.maximization}
            gridCode="document-context-list-rental-order"
            emptyState={{
              headline: i18n.t('page.vehicle.notifications.noDocuments'),
              subheadline: i18n.t('page.vehicle.notifications.documentListWillAppearHere'),
            }}
            actionCallback={actionCallback}
            predefinedColumns={DOCUMENT_ACTION_COLUMNS}
            data-testid={testIds.rentalOrder.rentVehicle('document-context-list-rental-order')}
            queryModifier={queryModifier}
          />
        </Box>
      </Card>
      <UploadDocumentsDialog
        isOpen={isUploadDialogOpen}
        handleClose={closeUploadDialog}
        onDocumentCreated={() => refreshDmsDatagrid('document-context-list-rental-order')}
        contextTarget="rental-order"
        contextId={rentalOrderId}
      />
    </>
  );
}
